import KanbanPage from "../../../components/kanban";

const MaintenanceMonitoring = (props: any) => {
    return <KanbanPage persona="MANAGER" {...props} />;
};

export default MaintenanceMonitoring;